// @flow
import * as React from 'react'
import Alert from 'mz-ui-kit/core/Alert'
import { PAY_FOR_FREE } from '../constants'
import { ButtonContainer, BeforeButtonWrapper } from './elements'

// Types
import type { MethodProps } from '..'

// Constants
const FREE_VALUE = { type: PAY_FOR_FREE }

const FreePaymentMethod = (props: MethodProps) => {
  const { renderBeforeButton, renderButton, loading, disabled, onClick } = props
  const thingsBeforeButton = !!renderBeforeButton && renderBeforeButton()

  return (
    <div>
      {!!props.freePaymentLabel && (
        <Alert color="green">{props.freePaymentLabel}</Alert>
      )}
      {thingsBeforeButton && (
        <BeforeButtonWrapper>{thingsBeforeButton}</BeforeButtonWrapper>
      )}
      <ButtonContainer>
        {renderButton({
          onClick: () => onClick && onClick(() => Promise.resolve(FREE_VALUE)),
          loading,
          disabled,
          isFree: true,
        })}
      </ButtonContainer>
    </div>
  )
}

export default FreePaymentMethod
